import styled from "@emotion/styled";
import { Box, Grid, IconButton, Link, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import Logo from "src/components/Logo";
import Container from "../Container";

const footerLinks = [
  {
    label: "common_questions",
    links: [
      {
        label: "start_investing",
        url: "#home-hero",
      },
      {
        label: "benefits",
        url: "#benefits-section",
      },
    ],
  },
  {
    label: "about_us",
    links: [
      {
        label: "how_to_operate",
        url: "#steps-section",
      },
      {
        label: "contacts",
        url: "mailto:suporte@ebinex.com",
      },
      {
        label: "FAQ",
        url: "#faq-section",
      },
    ],
  },
  // {
  //   label: "Regulamentos",
  //   links: [
  //     {
  //       label: "Política de privacidade",
  //       url: "",
  //     },
  //     {
  //       label: "Política de pagamento",
  //       url: "",
  //     },
  //     {
  //       label: "Acordo de serviço",
  //       url: "",
  //     },
  //     {
  //       label: "Advertência de risco",
  //       url: "",
  //     },
  //     {
  //       label: "Regras de operações comerciais",
  //       url: "",
  //     },
  //     {
  //       label: "Regulamentos de operações não-comerciais",
  //       url: "",
  //     },
  //   ],
  // },
  // {
  //   label: "Afiliados",
  //   links: [
  //     {
  //       label: "Inscrever-se",
  //       url: "",
  //     },
  //   ],
  // },
];

const SocialIconButton = styled(IconButton)(() => ({
  color: "#00DB97",
  backgroundColor: "#1F2225",
}));

const Footer: FC = () => {
  const { t } = useTranslation("footer");

  return (
    <Box component="footer">
      <Box
        sx={{
          py: 4,
          backgroundColor: "#4b4b4b26",
        }}
      >
        <Container>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} md={4}>
              <Stack spacing={1} alignItems={{ xs: "center", md: "start" }}>
                <Logo sx={{ width: 100, height: 24, mb: 2 }} />
              </Stack>
            </Grid>
            {footerLinks.map(({ label, links }) => (
              <Grid key={label} item xs={6} md={4}>
                <Stack spacing={1} alignItems={{ xs: "center", md: "start" }}>
                  <Box>
                    <Typography fontSize={16} fontWeight="bold">
                      {t(label)}
                    </Typography>
                    <Stack spacing={0.5}>
                      {links.map(({ label: linkLabel, url }) => (
                        <Link
                          href={url}
                          key={linkLabel}
                          variant="body1"
                          color="inherit"
                          underline="none"
                        >
                          {t(linkLabel)}
                        </Link>
                      ))}
                    </Stack>
                  </Box>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          py: 2,
          backgroundColor: "#19191926",
        }}
      >
        <Container>
          <Stack
            alignItems={{ md: "center" }}
            spacing={{ xs: 5, md: 10 }}
            direction={{ xs: "column", md: "row" }}
          >
            <Stack spacing={1}>
              <Typography
                fontSize={14}
                lineHeight={1.7}
                color="#B3B8BB"
                align="justify"
              >
                {t("description")}
                <Link href="mailto:suporte@ebinex.com">
                  {" "}
                  support@ebinex.global
                </Link>
              </Typography>
              <Typography fontSize={14} lineHeight={1.7} fontWeight="bold">
                {t("all_rights_reserved")}
              </Typography>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
